const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

const Themeable = forgeUiComponent('Themeable', null, function ThemeableConstructor(rootElement, options, componentBuilder) {
  const self = this;
  var styleSheetIndex;

  componentBuilder.defineClassState('switching', 'is-switching');

  Object.defineProperty(this, 'themeStyleSheets', {
    get: function getThemeStyleSheets() {
      return styleSheetIndex;
    },
    set: function setThemeStyleSheets(styleSheets) {
      styleSheetIndex = styleSheets;
    }
  });

  this.element.addEventListener(events.themeChange, function (e) {
    if (e.detail && e.detail.themeName) {
      self.switch(e.detail.themeName);
    }
  });

  // Cache the theme definition
  this.reindex();
});

Themeable.prototype.reindex = function indexThemes() {
  const stylesheets = this.element.querySelectorAll('link.Themeable-styleSheet');
  this.themeStyleSheets = Array.prototype.reduce.call(stylesheets, function groupStyleSheets(themes, stylesheet) {
    const themeName = stylesheet.getAttribute('data-theme');
    // You must set `data-theme` on appropraite stylesheets else they'll be ignored.
    if (!themeName) {
      return themes;
    }
    themes[themeName] = themes[themeName] || [];
    themes[themeName].push(stylesheet);
    return themes;
  }, {});
  return this.themeStyleSheets;
};

Themeable.prototype.disable = function disableTheme(name) {
  const themes = this.themeStyleSheets;
  (themes[name] || []).forEach(function disable(styleSheet) {
    styleSheet.disabled = true;
  });
};

/**
 * Enables a set of theme stylesheets. Note: Does not also disable other themes (use `switch`), so the natural
 * cascade kicks in.
 * @param {String} name The name of the theme to be enabled
 */
Themeable.prototype.enable = function enableTheme(name) {
  const themes = this.themeStyleSheets;
  const styleSheets = themes[name] || [];
  styleSheets.forEach(function disable(styleSheet) {
    // If <link> was included but not marked up to load with the page, set metadata now:
    if (styleSheet.rel !== 'stylesheet') {
      styleSheet.rel = 'stylesheet';
    }
    styleSheet.disabled = false;
  });
  // Return the stylesheets that are being enabled, as we may need to monitor their load status
  return styleSheets;
};

Themeable.prototype.persist = function setPersistanceCookie(name) {
  document.cookie = [
    'theme=', encodeURIComponent(name),
    ';max-age=', (60 * 60 * 24 * 365 * 10),
    ';path=/',
    ';secure'].join('');
};

/**
 * Enables the specified theme (if it exists) and disables all others. Themes are specified using `data-theme=name` on
 * the `<link>` element(s) for their stylesheets. This assumes that only one theme may be enabled at a time.
 * stylesheets without a theme name are ignored.
 * @param {String} name The name of the theme to be enabled
 */
Themeable.prototype.switch = function switchTheme(name) {
  const self = this;
  const themes = Object.keys(this.themeStyleSheets);
  if (themes.indexOf(name) < 0) {
    return;
  }
  self.switching = true;

  const newStyleSheets = this.enable(name);
  const awaitingStyleSheets = newStyleSheets.filter(function (link) { return !link.sheet; });
  const disableOthers = function disableOtherStyleSheets() {
    themes.filter(function (t) { return t !== name; }).forEach(function (themeName) {
      self.disable(themeName);
    });
    self.switching = false;
    self.dispatchEvent(events.themeWasChanged, { themeName: name });
  };

  if (awaitingStyleSheets.length === 0) {
    disableOthers();
  } else {
    awaitingStyleSheets.forEach(function handleStyleSheetLoad(link) {
      link.addEventListener('load', function styleSheetLoaded() {
        const remainingStyleSheets = newStyleSheets.filter(function (remainingLink) { return !remainingLink.sheet; });
        if (remainingStyleSheets.length === 0) {
          disableOthers();
        }
      });
    });
  }

  this.persist(name);
};

module.exports = Themeable;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/themeable.js
// module id = 76
// module chunks = 0